var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackwardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "#201F4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1599 19.4159C28.5277 19.0514 28.5303 18.4578 28.1659 18.0901C27.8014 17.7223 27.2078 17.7197 26.8401 18.0841L24.5966 20.3076C23.7517 21.1451 23.0611 21.8295 22.5713 22.4393C22.062 23.0735 21.6934 23.7172 21.5949 24.4898C21.5517 24.8286 21.5517 25.1714 21.5949 25.5102C21.6934 26.2828 22.062 26.9265 22.5713 27.5607C23.0611 28.1705 23.7517 28.8549 24.5966 29.6924L26.8401 31.9159C27.2078 32.2803 27.8014 32.2777 28.1659 31.9099C28.5303 31.5422 28.5277 30.9486 28.1599 30.5841L25.9562 28.4C25.0619 27.5136 24.4484 26.9035 24.0332 26.3866C23.63 25.8845 23.4917 25.562 23.4548 25.2731C23.4317 25.0918 23.4317 24.9082 23.4548 24.7269C23.4917 24.438 23.63 24.1155 24.0332 23.6134C24.4484 23.0965 25.0619 22.4864 25.9562 21.6L28.1599 19.4159Z",
    fill: "#201F4F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardIcon);
export default __webpack_public_path__ + "static/media/backward-icon.9b6b322b3828e503490b89083ad07efc.svg";
export { ForwardRef as ReactComponent };